import type { EmptyPrefetchProps } from 'src/shared/prefetch';
import { withPrefetchedData } from 'src/shared/prefetch';

import { Layout } from '../layout';

export const Open = withPrefetchedData(
	function Open(_props: EmptyPrefetchProps) {
		return <Layout />;
	},
	{
		prefetchName: __MODULE_HASH__,
		pageTitle: ({ i18n, fromTemplate }) => fromTemplate(i18n.translate('fe.pages.open_platform.title')),
		pageMetadata: ({ i18n }) => {
			const title = i18n.translate('fe.pages.open_platform.title');
			const description = i18n.translate('fe.pages.open_platform.description');
			return {
				description,
				ogTitle: title,
				ogDescription: description,
				ogType: 'website',
				twitterCard: 'summary',
			};
		},
	},
);
